import {TranslateEnumParams} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';

import {
  CELL_RENDERER_PARAMS,
  CELL_RENDERER_PARAMS_AG,
} from 'src/js/model/cell_renderer_params';

export function baseTranslateEnumFormatterParams(
  params: ICellRendererParams
): TranslateEnumParams {
  const {colDef, value} = params;
  const formatterParams =
    colDef?.[CELL_RENDERER_PARAMS_AG] || colDef?.[CELL_RENDERER_PARAMS] || {};
  const {enumName} = formatterParams;

  const enumValueName = value;

  return {enumValueName, enumName};
}
